import { render } from "./ListProduct.vue?vue&type=template&id=3453e6f1"
import script from "./ListProduct.vue?vue&type=script&lang=js"
export * from "./ListProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__